var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "mb-1" }, [_vm._v("Excluded:")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex flex-wrap" },
      _vm._l(_vm.items, function (item) {
        return _c(
          "item",
          _vm._b(
            { key: item.id, staticClass: "badge badge-purple mr-1 mb-1" },
            "item",
            item,
            false
          )
        )
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }